import React from 'react'
import GenericTable from 'components/Table/GenericTable'
import { defaultProps } from 'components/Table/PartnerInterestTable/component'

export const PartnerInterestTable = ({ data }) => {
  return <GenericTable {...defaultProps} rows={data} />
}
